import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { FC, ReactNode } from 'react';
import { RoomStateEnum } from '../../../models';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const StateField: FC<{
  value: RoomStateEnum[] | null;
  onChange: (value: RoomStateEnum[] | null) => void;
  error?: ReactNode;
}> = ({ value, onChange, error }) => {
  const handleChange = (roomState: RoomStateEnum) => {
    if (roomState === ('all' as unknown as RoomStateEnum)) {
      onChange(null);
      return;
    }

    const currentValues = value ?? [];
    const newValues = currentValues.includes(roomState)
      ? currentValues.filter(id => id !== roomState)
      : [...currentValues, roomState];

    onChange(newValues.length > 0 ? newValues : null);
  };

  return (
    <Box
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink>Room State</InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={!value}
                  onChange={() => handleChange('all' as unknown as RoomStateEnum)}
                  sx={{ mr: 1 }}
                />
              }
              label={'ALL'}
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {(Object.values(RoomStateEnum) || [])?.map(item => (
              <FormControlLabel
                key={item}
                control={
                  <Checkbox
                    checked={value?.includes(item) ?? false}
                    onChange={() => handleChange(item)}
                    sx={{ mr: 1 }}
                  />
                }
                label={item}
                sx={{ py: 0.5, pl: 1.5 }}
              />
            ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
